// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3FzxN flex flex-column items-center justify-start bgWhiteTexture","content":"styles_content__2toUS flex flex-column items-center justify-start"};